import moment from "moment";

export const convertDate = (date, mask = "DD/MM/YYYY") => {
  if (date) {
    return moment(date).format(mask);
  }
  return "";
};
